import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { usersAPI, profileAPI } from "../../api/api.js";

export const getUserProfileThunk = createAsyncThunk(
    'profilePage/getUserProfileThunk',
    async ({newUserId}) => {
        const [data, followed, status] = await Promise.all([
            profileAPI.getUserData(newUserId), 
            profileAPI.getUserFollowed(newUserId),
            profileAPI.getStatus(newUserId),
        ]);
        return { data, followed, status };
    }
);

export const setUserPhotoThunk = createAsyncThunk(
    'profilePage/setUserPhotoThunk',
    async ({ image }) => {
        return await profileAPI.setUserPhoto(image);
    } 
)

export const setUserDataThunk = createAsyncThunk(
    'profilePage/setUserDataThunk',
    async ({ fullData }) => {
        const responseSetData = await profileAPI.setUserData({ ...fullData });
        const responseGetData = (responseSetData.resultCode === 0)
            ? await profileAPI.getUserData(fullData.userId)
            : responseSetData;
        return responseGetData;
        return responseSetData;
    }
)
export const setFollowThunkProfile = createAsyncThunk(
    'profilePage/setFollowThunkProfile',
    async ({ id, followed }) => {
        const response = !followed 
                ? await usersAPI.setFollow(id)
                : await usersAPI.setUnfollow(id)
        return { response, id };
    }
);

export const updateStatusThunk = createAsyncThunk(
    'profilePage/updateUserStatus',
    async ({ statusText }) => {
        const response = await profileAPI.updateStatus(statusText);
        return { response, statusText };
    }
);

const initialState = {
    userInfo: {
        userId: null,
        fullName: '',
        photos: {
            large: '',
            small: '',
        },
        status: '',
        aboutMe: '',
        posts: [],
        lookingForAJob: false,
        lookingForAJobDescription: '',
        contacts: [],
        followed: false,
    },
    isFetching: false,
    isRequestFollow: [],
    errors: {
        avatar: null,
        editForm: null,
    }
};

const profileSlice = createSlice({
    name: 'profilePage',
    initialState,
    reducers: {
        addPost(state, action) {
            const postArray = state.userInfo.posts;
            let id = 0;
            if (postArray) {
                for (let i = 1; i <= postArray.length + 1; i++) {
                    !postArray[i - 1] && (id = i);
                }
            } else {
                id = 1;
            }
            postArray.push(
                {
                    id,
                    message: action.payload,
                    likesCount: 0,
                }
            );
        },
        deletePost(state, action) {
            state.userInfo.posts
                .filter((post) => post.id !== action.payload);
        }
    },
    extraReducers: (build) => {
        (function getUserProfile() {
            build.addCase(
                getUserProfileThunk.pending, (state) => {
                    state.isFetching = true;
                    state.errors = {
                        avatar: null,
                        editForm: null,
                    }
                });
            build.addCase(
                getUserProfileThunk.fulfilled, (state, action) => {
                    state.userInfo = {
                        ...action.payload.data,
                        posts: [],
                        status: action.payload.status,
                        followed: action.payload.followed
                    }

                    state.isFetching = false;
                });
            build.addCase(
                getUserProfileThunk.rejected, (state) => {
                    console.log('Fetching is rejected!');
                    state.isFetching = false;
                });
        })();

        (function setPhoto() {
            build.addCase(setUserPhotoThunk.pending, (state) => {
                state.errors.avatar = null;
            })
            build.addCase(setUserPhotoThunk.fulfilled, (state, action) => {
                if (action.payload.messages.length) {
                    state.errors.avatar = action.payload.messages[0];
                };
                if (action.payload.resultCode === 0) {
                    state.userInfo.photos = action.payload.data.photos;
                }
            });
            build.addCase(setUserPhotoThunk.rejected, () => {
                console.log('Set photo is rejected!');
            })
        })();

        (function setUserData() {
            build.addCase(setUserDataThunk.pending, (state, action) => {
                state.errors.editForm = null;
            });
            build.addCase(setUserDataThunk.fulfilled, (state, action) => {
                if (action.payload.resultCode === undefined) {
                    const status = state.userInfo.status;
                    const posts = state.userInfo.posts;
                    state.userInfo = {
                        ...action.payload,
                        posts,
                        status,
                    }
                } else {
                    state.errors.editForm = action.payload.messages[0];
                }
            });
            build.addCase(setUserDataThunk.rejected, () => {
                console.log('Set data is rejected');
            })
        })();

        (function setFollow() {
            build.addCase(
                setFollowThunkProfile.pending, (state, action) => {
                    state.isRequestFollow.push(Number(action.meta.arg.id));
                });
            build.addCase(
                setFollowThunkProfile.fulfilled, (state, action) => {
                    if (action.payload.response.resultCode === 0) {
                        (Number(state.userInfo.userId) === Number(action.payload.id))
                            && (state.userInfo.followed = !state.userInfo.followed);
                    }
                    state.isRequestFollow = state.isRequestFollow
                        .filter((id) => id !== Number(action.payload.id));
                });
            build.addCase(
                setFollowThunkProfile.rejected, (state, action) => {
                    console.log('Follow is rejected');
                    state.isRequestFollow = state.isRequestFollow
                        .filter((id) => id !== Number(action.meta.arg.id));
                })
        })();

        (function updateStatus() {
            build.addCase(updateStatusThunk.pending, (state, action) => {

            })
            build.addCase(updateStatusThunk.fulfilled, (state, action) => {
                if (Number(action.payload.response.resultCode) === 0) {
                    state.userInfo.status = action.payload.statusText;
                }
            })
            build.addCase(updateStatusThunk.rejected, (state, action) => {
                console.log('Status update is rejected');
            })
        })();
    }
});

export const { updateNewTextPost, addPost, deletePost } = profileSlice.actions;

export default profileSlice.reducer;